import { CreateElement } from 'vue';
import { Component } from 'vue-property-decorator';
import { PropsMixin } from './PropsMixin';
import { http } from '@/http';
import { SlideStruct } from './types';
import BannerSlider from './BannerSlider.vue';
import DefaultSlider from './DefaultSlider.vue';
import FullscreenSlider from './FullscreenSlider.vue';

@Component({
    components: {
        BannerSlider,
        DefaultSlider,
        FullscreenSlider,
    },
})
export default class SliderManager extends PropsMixin {
    /**
     *
     */
    public resolvedSlides: SlideStruct[] = [];
    /**
     *
     */
    public async resolveSlides() {
        if (Array.isArray(this.$props.slides)) {
            this.resolvedSlides = this.$props.slides;
        } else if (this.$props.url) {
            const { data } = await http.get(this.$props.url);
            this.resolvedSlides = data;
        } else {
            console.warn(`[${this.$options.name}]: empty slides`);
        }
    }
    /**
     *
     */
    public created() {
        this.$wait.start('resolveSlides');
        this.resolveSlides();
        this.$wait.end('resolveSlides');
    }
    /**
     *
     */
    public render(h: CreateElement) {
        if (this.$wait.waiting('resolveSlides')) {
            return;
        }

        return h(this.component, {
            props: Object.assign({}, this.$props, { slides: this.resolvedSlides }),
        });
    }
}
